import React from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import { HiddenProps } from './types';
import { BiData, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';

const MatureAnonymousBlockedOverlay: React.FC<HiddenProps> = props => {
  const { t } = useTranslation();

  return (
    <HiddenLayout
      icon={<HiddenIcon size={IconSize.HUGE} />}
      text={t('deviationview.blocked.mature.text')}
      button={
        <GhostButton
          variant="main"
          size="medium"
          href={Url.joinLink('mature')}
          biData={BiData<RedirectToLoginBiEvent>({
            evid: 240,
            referral_info: ReferralType.MATURE,
          })}
        >
          {t('deviationview.blocked.nsfg.anon.signIn')}
        </GhostButton>
      }
      {...props}
    />
  );
};
MatureAnonymousBlockedOverlay.displayName = 'MatureAnonymousBlockedOverlay';

export default MatureAnonymousBlockedOverlay;
